import { render } from "./PersonCard.vue?vue&type=template&id=030a3130&scoped=true"
import script from "./PersonCard.vue?vue&type=script&lang=js"
export * from "./PersonCard.vue?vue&type=script&lang=js"

import "./PersonCard.vue?vue&type=style&index=0&id=030a3130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030a3130"]])

export default __exports__